import commonCss from "PFApp/activities/show/activity_page/activity_page.module.scss";
import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import {
  useActivityCompareStore,
  useActivityCompareStoreActions
} from "PFApp/activities/show/store/activity_compare";
import { MatchCard } from "PFApp/components/activity_match_card";
import { LoadingDots } from "PFComponents/loading_dots";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";

import { ShortlistTableEntry } from "../../../../activity_tabs.utils";
import css from "./shortlists_view.module.scss";

type ShortlistsCardsViewProps = {
  shortlistsEntries: ShortlistTableEntry[];
  isLoading: boolean;
};

export const ShortlistsCardsView = ({ shortlistsEntries, isLoading }: ShortlistsCardsViewProps) => {
  const activity = useCurrentActivity();
  const { isFillDisabled } = useActivityShowContext();
  const { addProfileToComparison, removeProfileFromComparison } = useActivityCompareStoreActions();

  const { compareIds } = useActivityCompareStore((state) => ({ compareIds: state.compareIds }));

  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);

  return (
    <div className={commonCss.pageCardEntriesList} data-qa-id="ActivityShortlistsTabCardsContainer">
      {isLoading && <LoadingDots circlesEnabled circleSize="xs" className={commonCss.loading} />}

      {shortlistsEntries.map(({ shortlist, match }) => (
        <MatchCard
          key={shortlist.id}
          match={match}
          shortlist={shortlist}
          role={activity!}
          isUnbiasedMode={isUnbiasedMode}
          isProfileSelectedToCompare={compareIds[shortlist.profile.id]}
          addProfileToComparison={addProfileToComparison}
          removeProfileFromComparison={removeProfileFromComparison}
          isFillDisabled={isFillDisabled}
          areButtonsDisabled={isLoading}
          classes={{
            card: css.card
          }}
        />
      ))}
    </div>
  );
};
